import { Redirect, useRouteMatch } from 'react-router-dom';

type Props = {
  resolve: (path: string, params: URLSearchParams) => string | null;
};

/**
 * This component is used to redirect deep links to the correct page.
 * Deep links serve as a contract with external services to link to specific
 * pages within the app without having to know the internal workings of our
 * routes in React.
 * The target of the deep link must be stable forever.
 */
const DeepLinks = ({ resolve }: Props) => {
  const match = useRouteMatch<{ target: string }>({ path: '/go/:target' });
  if (!match) {
    return null;
  }

  const { target } = match.params;

  const params = new URLSearchParams(window.location.search);

  const path = resolve(target, params);

  if (path) {
    const url = new URL(`${window.location.origin}${path}`);
    // the path might include search params, so we need to merge them
    Array.from(url.searchParams.entries()).forEach(([key, value]) => params.set(key, value));
    return (
      <Redirect
        to={{ pathname: url.pathname, search: params.toString(), hash: window.location.hash }}
      />
    );
  }

  return null;
};

export default DeepLinks;
